import { CommonEnums } from '../../common.enums';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Param } from './param';
import { DxMp_Inst } from './dxmp_inst';
import { DObj_Inst_Property } from './dobj_inst_property';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { ParamsUtil } from '../utils/params.util';
import { DObj_Inst_PropertiesUtil } from 'src/app/shared/utils/dobj_inst_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { RepConn } from '../datapoint/repconn';
import { SQLOverride } from '../stream/jobs/sqloverride';
import { Rce_DxSubUnit } from '../stream/jobs/rce_dxsubunit';
import { SQLOverrideUtil } from '../utils/sqloverrides.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Design } from './design';

export class DesignJob {
    fldr_Id: number;
    dxMp_Inst: DxMp_Inst;
    design: Design;

    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dObj_Inst_Properties: Array<DObj_Inst_Property>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;

    params: Array<Param>;

    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldrNm: string;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    sel_Run_PropertyType_Cd: string;
    imageUrl: string;
    sqlOverrides: Array<SQLOverride>;

    unit_SubUnitsMap: Map<number, Array<Rce_DxSubUnit>>;
    repConn: RepConn;
    runtime_Change_Ind: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Inst = new DxMp_Inst();
        this.design = new Design();

        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();

        this.dObj_Inst_Properties = new Array<DObj_Inst_Property>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();

        this.params = new Array<Param>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;

        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.sqlOverrides = new Array<SQLOverride>();
        this.unit_SubUnitsMap = new Map<number, Array<Rce_DxSubUnit>>();
        this.repConn = new RepConn();
        this.runtime_Change_Ind = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(designJobTmp: DesignJob): DesignJob {
        let designJob = new DesignJob();
        designJob.copyFrom(designJobTmp as DesignJob);
        return designJob;
    }

    getPrimaryKey(): string {
        return this.fldr_Id + '.' + this.ref_Id;
    }

    copy(): DesignJob {
        let designjobTmp: DesignJob = new DesignJob();

        designjobTmp.fldr_Id = this.fldr_Id;
        designjobTmp.dxMp_Inst = this.dxMp_Inst.copy();
        designjobTmp.design = this.design;

        designjobTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        designjobTmp.dObj_Inst_Properties = DObj_Inst_PropertiesUtil.getInstance().copy(this.dObj_Inst_Properties);
        designjobTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        designjobTmp.params = ParamsUtil.getInstance().copy(this.params);
        designjobTmp.change_Ind = this.change_Ind;
        designjobTmp.error_Cd = this.error_Cd;
        designjobTmp.error_Msg = this.error_Msg;
        designjobTmp.ref_Id = this.ref_Id;
        designjobTmp.ref_Cd = this.ref_Cd;
        designjobTmp.fldrNm = this.fldrNm;
        designjobTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        designjobTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);
        designjobTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        designjobTmp.imageUrl = this.imageUrl;
        designjobTmp.repConn = this.repConn;
        designjobTmp.sqlOverrides = SQLOverrideUtil.getInstance().copy(this.sqlOverrides);
        designjobTmp.unit_SubUnitsMap = this.unit_SubUnitsMap;
        designjobTmp.runtime_Change_Ind = this.runtime_Change_Ind;

        return designjobTmp;
    }

    copyFrom(designjobTmp: DesignJob): void {
        this.fldr_Id = designjobTmp.fldr_Id;
        this.dxMp_Inst.copyFrom(designjobTmp.dxMp_Inst);
        this.design = designjobTmp.design;
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, designjobTmp.conn_Db_Obj_Lnks);
        DObj_Inst_PropertiesUtil.getInstance().copyFrom(this.dObj_Inst_Properties, designjobTmp.dObj_Inst_Properties);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, designjobTmp.dxFlow_Obj_Properties);
        ParamsUtil.getInstance().copyFrom(this.params, designjobTmp.params);
        this.change_Ind = designjobTmp.change_Ind;
        this.error_Cd = designjobTmp.error_Cd;
        this.error_Msg = designjobTmp.error_Msg;
        this.ref_Id = designjobTmp.ref_Id;
        this.ref_Cd = designjobTmp.ref_Cd;
        this.fldrNm = designjobTmp.fldrNm;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, designjobTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, designjobTmp.runPropertyTypes);
        this.sel_Run_PropertyType_Cd = designjobTmp.sel_Run_PropertyType_Cd;

        this.imageUrl = designjobTmp.imageUrl;
        if (designjobTmp.repConn)
            this.repConn = RepConn.parse(designjobTmp.repConn);
        SQLOverrideUtil.getInstance().copyFrom(this.sqlOverrides, designjobTmp.sqlOverrides);
        this.unit_SubUnitsMap = designjobTmp.unit_SubUnitsMap;
        this.runtime_Change_Ind = designjobTmp.runtime_Change_Ind;
    }

    compare(designjobTmp: DesignJob): string {
        let diffString = '';

        diffString = (this.dxMp_Inst).compare(designjobTmp.dxMp_Inst);
        if (diffString != '') return diffString;

        diffString = DObj_Inst_PropertiesUtil.getInstance().compare(this.dObj_Inst_Properties, designjobTmp.dObj_Inst_Properties)
        if (diffString! = '') return diffString;
        diffString = ParamsUtil.getInstance().compare(this.params, designjobTmp.params);
        if (diffString != '') return diffString;

        diffString = SQLOverrideUtil.getInstance().compare(this.sqlOverrides, designjobTmp.sqlOverrides);
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, designjobTmp.dxFlow_Obj_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, designjobTmp.run_Properties);
        if (diffString != ''){
            this.runtime_Change_Ind = 'Y';
            return diffString;
        } else {
            this.runtime_Change_Ind = 'N';
        }

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, designjobTmp.runPropertyTypes)

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, designjobTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DesignJob [fldr_Id=" + this.fldr_Id +
            ", dxMp_Inst=" + this.dxMp_Inst.toString() +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dObj_Inst_Properties=" + DObj_Inst_PropertiesUtil.getInstance().toString(this.dObj_Inst_Properties) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", params=" + this.params +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id =" + this.ref_Id +
            "design =" + this.design +
            ", ref_Cd =" + this.ref_Cd +
            ", fldrNm =" + this.fldrNm +
            ",unit_SubUnitsMap=" + this.unit_SubUnitsMap +
            ", run_Properties =" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes =" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes) +
            ", sel_Run_PropertyType_Cd =" + this.sel_Run_PropertyType_Cd +
            "repConn =" + this.repConn +
            ", imageUrl = " + this.imageUrl +
            ",runtime_Change_Ind = " + this.runtime_Change_Ind;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}














































































